import { Injectable, Injector } from '@angular/core';
import { SignalConfigurationDto } from '@common-modules/dependencies/signals/models/signal-configuration.dto';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';

@InjectableByKey({ key: 'PointConfigurationService' })
@Injectable({ providedIn: 'root' })
export class PointConfigurationService extends GridODataService<SignalConfigurationDto> {
  constructor(injector: Injector) {
    super(injector, '/api/telemetry/signal/configuration');
  }

  protected mapResponse(
    response: PagedResultDto<SignalConfigurationDto>
  ): PagedResultDto<SignalConfigurationDto> {
    return response;
  }
}
